import React, { useState, useEffect } from "react";
import { useUserStore } from "../../../store/userStore.js";


import EditProfileBoxLabel from "../../../components/label/editprofileboxlabel";
import EditProfileMultipleSelect from "../../../components/dropdown/editprofilemultipleselection";
import PrimaryButton from "../../../components/button/primarybutton";
import Loader from "../../../components/loader/loader";
import Spacer from "../../../components/spacer/spacer";

import {
  food,
  music,
  personalityTraits,
  hobbies,
  books,
  countries,
  weekend,
} from "../../../utils/arrayitems";

import images from "../../../assets";

import TabHeading from "./tabheading";
import "./styles.css";

const PersonalityHobby = () => {
  const { user, isUserLoading, getUser, updateUser } = useUserStore();

  const [state, setState] = useState({
    foodPreference: [],
    musicPreference: [],
    personalityTraits: [],
    visitedCountries: [],
    weekendPreference: [],
    bookPreference: [],
    hobbies: [],
  });

  useEffect(() => {
    setState({
      ...state,
      foodPreference: user?.foodPreference ?? [],
      musicPreference: user?.musicPreference ?? [],
      personalityTraits: user?.personalityTraits ?? [],
      visitedCountries: user?.visitedCountries ?? [],
      weekendPreference: user?.weekendPreference ?? [],
      bookPreference: user?.bookPreference ?? [],
      hobbies: user?.hobbies ?? [],
    });
  }, [isUserLoading]);

  const getprofileData = () => {
    const payload = { username: user?.username };
    getUser(payload);
  };

  const handleSubmit = () => {
    const payload = { username: user?.username, data: state };
    updateUser(payload, () => {
      getprofileData();
    });
  };

  return (
    <>
      <TabHeading
        image={images.editProfileEducation}
        title="Personality & Hobbies"
        subtitle="Complete to easily find your ideal partner!"
      />
      <div className="edit-profile-content">
        {isUserLoading ? (
          <Loader />
        ) : (
          <>
            {/* What sort of food do you like? */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="What sort of food do you like?" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="What sort of food do you like?"
              data={food}
              onChange={(e) => setState({ ...state, foodPreference: e })}
              value={state.foodPreference || undefined}
            />
            <Spacer height="12px" />
            {/* What sort of music do you like? */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="What sort of music do you like?" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="What sort of music do you like?"
              data={music}
              onChange={(e) => setState({ ...state, musicPreference: e })}
              value={state.musicPreference || undefined}
            />
            <Spacer height="12px" />
            {/* What are your main personality traits? */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="What are your main personality traits?" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="What are your main personality traits?"
              data={personalityTraits}
              onChange={(e) => setState({ ...state, personalityTraits: e })}
              value={state.personalityTraits || undefined}
            />
            <Spacer height="12px" />
            {/* What are the countries you visited? */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="What are the countries you visited?" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="What are the countries you visited?"
              data={countries}
              onChange={(e) => setState({ ...state, visitedCountries: e })}
              value={state.visitedCountries || undefined}
            />
            <Spacer height="12px" />
            {/* How would you like to spend weekend with your family? */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="How would you like to spend weekend with your family?" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="How would you like to spend weekend with your family?"
              data={weekend}
              onChange={(e) => setState({ ...state, weekendPreference: e })}
              value={state.weekendPreference || undefined}
            />
            <Spacer height="12px" />
            {/* What are the types of books you like? */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="What are the types of books you like?" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="What are the types of books you like?"
              data={books}
              onChange={(e) => setState({ ...state, bookPreference: e })}
              value={state.bookPreference || undefined}
            />
            <Spacer height="12px" />

            {/* What are your hobbies? */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="What are your hobbies?" />
            </div>
            <Spacer height="8px" />
            <EditProfileMultipleSelect
              placeholder="What are your hobbies?"
              data={hobbies}
              onChange={(e) => setState({ ...state, hobbies: e })}
              value={state.hobbies || undefined}
            />
          </>
        )}
        <Spacer height="32px" />
        <PrimaryButton
          text="Save & Continue"
          onClick={handleSubmit}
          disabled={isUserLoading}
        />
      </div>
    </>
  );
};

export default PersonalityHobby;








